import {DeviceInfo} from "@/business/ComponentViews/DeviceInfo"

export class DeviceStore {
  public static setDataSet( store: any, payload: DeviceInfo) {
    store.commit("devicestore/setDataset", payload)
  }

  public static getDataset( store: any) : DeviceInfo {
    return store.getters["devicestore/getDataSet"]
  }

}

export const devicestore = {
  namespaced: true,
  state: {
    deviceInfo: {
      devices: []
    }
  },

  mutations: {
    setDataset: function(state: any, payload: DeviceInfo ) {
      state.deviceInfo = payload
    }
  },

  getters: {
    getDataSet: function(state: any) : DeviceInfo {
      return state.deviceInfo;
    }
  }

}